enum PlantStatusEnum {
  ALL = "ALL",
  TO_CONTROL = "TO_CONTROL",
  COMPLIANT = "COMPLIANT",
  NOT_COMPLIANT = "NOT_COMPLIANT",
  CONTROL_IN_PROGRESS = "CONTROL_IN_PROGRESS",
}

export default PlantStatusEnum;
